import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/bar-chart-07.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M2.5 17.7998V3C2.5 2.44772 2.94772 2 3.5 2C4.05229 2 4.5 2.44772 4.5 3V17.7998C4.5 18.3764 4.50127 18.7489 4.52442 19.0322C4.54662 19.3038 4.58419 19.4047 4.60938 19.4541C4.70522 19.6421 4.85793 19.7948 5.0459 19.8906C5.09534 19.9158 5.19619 19.9534 5.46778 19.9756C5.75112 19.9987 6.12365 20 6.7002 20H21.5C22.0523 20 22.5 20.4477 22.5 21C22.5 21.5523 22.0523 22 21.5 22H6.7002C6.15665 22 5.68836 22.0011 5.30469 21.9697C4.90943 21.9374 4.516 21.8656 4.1377 21.6729C3.57348 21.3853 3.11473 20.9265 2.82715 20.3623C2.6344 19.984 2.56259 19.5906 2.53028 19.1953C2.49893 18.8116 2.5 18.3434 2.5 17.7998ZM6.5 17.5V10.5C6.5 9.94772 6.94772 9.5 7.5 9.5C8.05229 9.5 8.5 9.94772 8.5 10.5V17.5C8.5 18.0523 8.05229 18.5 7.5 18.5C6.94772 18.5 6.5 18.0523 6.5 17.5ZM11 17.5V5.5C11 4.94772 11.4477 4.5 12 4.5C12.5523 4.5 13 4.94772 13 5.5V17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5ZM15.5 17.5V10.5C15.5 9.94772 15.9477 9.5 16.5 9.5C17.0523 9.5 17.5 9.94772 17.5 10.5V17.5C17.5 18.0523 17.0523 18.5 16.5 18.5C15.9477 18.5 15.5 18.0523 15.5 17.5ZM20 17.5V5.5C20 4.94772 20.4477 4.5 21 4.5C21.5523 4.5 22 4.94772 22 5.5V17.5C22 18.0523 21.5523 18.5 21 18.5C20.4477 18.5 20 18.0523 20 17.5Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as BarChart07Icon };
